import { getFlujo } from 'utils/fujo'

export const URL_PATH = () => `/${getFlujo()}/login/`
export const FORMAT_EMAIL = /[ !#$%^&*()+=\][¨/{};':"\\|<>?]/
